const initialState = {
	isAuth: false,
	ui: null,
	uic: null,
	datetime: null,
};


export default function reducer(state = initialState, action) {

	if (action.type === "AUTH_SET"){
		let newState = {
			isAuth: action.payload.isAuth,
			ui: action.payload.ui,
			uic: action.payload.uic,
			datetime: (new Date()),
		}
		return newState;
	}
	else if (action.type === "AUTH_INIT"){
		return initialState;
	}
	else {
		return state;
	}

}
